import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import FinancialProductRulesEditDetailsOutputDataTableRow from './FinancialProductRulesEditDetailsOutputDataTableRow';
import { sequence, get } from '@totalsoft/change-tracking-react';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
import { StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsOutputDataTableBody = ({
  canWrite,
  dirtyInfo,
  outputDataList,
  financialProductRuleOutputDataParamList,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleOutputDataValidation
}) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(financialProductRuleOutputDataValidation) &&
        !sequence(outputDataList)?.find((_, index) => {
          return !isValid(financialProductRuleOutputDataValidation[index]);
        }) && (
          <StyledTableRow>
            <Typography color='error'>{t('FinancialProduct.Details.Rules.Details.OutputData.ValidationList')}</Typography>
          </StyledTableRow>
        )}
      {sequence(outputDataList)?.map((data, index) => {
        return (
          <FinancialProductRulesEditDetailsOutputDataTableRow
            canWrite={canWrite}
            dirtyInfo={dirtyInfo[index]}
            key={`${index}_${data.financialProductRuleOutputDataId |> get}`}
            financialProductRuleOutputDataParamList={financialProductRuleOutputDataParamList}
            dataLens={data}
            index={index}
            onCloseEdit={onCloseEdit}
            onDelete={onDelete}
            onSave={onSave}
            validation={financialProductRuleOutputDataValidation[index]}
            listValid={isValid(financialProductRuleOutputDataValidation)}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductRulesEditDetailsOutputDataTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  dirtyInfo: PropTypes.object.isRequired,
  outputDataList: PropTypes.object.isRequired,
  financialProductRuleOutputDataParamList: PropTypes.array.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleOutputDataValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsOutputDataTableBody;
